import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderCell,
  TableRow,
  Pagination,
} from "../../../../components";
import { Stack, Text } from "@fluentui/react";
import Layout from "../../../../styles/Layout.styles";
import { useSelector } from "react-redux";
import ProjectSummaryAwaitRow from "./ProjectSummaryAwaitRow";
import { useTranslation } from "react-i18next";
import { useProjectSummaryAwaitMutation } from "../../../../store/action/projectSummary/projectSummaryAwait";
import { setProjectSummaryAwait } from "../../../../store/reducer/projectSummary/projectSummaryAwait";

const ProjectSummaryAwait = ({
  status,
  projectSummaryId,
  openSummaryDetails,
  setOpenSummaryDetails,
  setProjectSummaryId,
}) => {
  const layout = Layout();
  const [getProjectSummaryApi, { isLoading }] =
    useProjectSummaryAwaitMutation();
  const [initialLoad, setInitialLoad] = useState(true);
  const projectSummaryAwait = useSelector((state) => state.projectSummaryAwait);

  const { t } = useTranslation();

  useEffect(() => {
    if (initialLoad) {
      if (!isLoading) {
        getProjectSummaryStatusApi();
        setInitialLoad(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getProjectSummaryApi, isLoading, initialLoad]);

  const getProjectSummaryStatusApi = async () => {
    await getProjectSummaryApi({ status });
  };

  const columns = [
    {
      columnKey: "projectCode",
      label: t("project_summary.project_id"),
      isSort: true,
    },
    {
      columnKey: "title",
      label: t("project_summary.project_name"),
      isSort: true,
    },
    {
      columnKey: "commencementDate",
      label: t("project_summary.commencement_date"),
      isSort: true,
    },
    {
      columnKey: "completionDate",
      label: t("project_summary.completion_date"),
      isSort: true,
    },
    {
      columnKey: "totalTeamMember ",
      label: t("project_summary.total_team_member"),
    },
    { columnKey: "todaysClockin", label: t("project_summary.today_clockin") },
  ];

  return (
    <>
      <Stack className={layout.flex_row}>
        <Stack className={layout.w_100}>
          <Stack className="overflow-x-auto">
            <Table className="tbl-layout-auto">
              <TableHeader className={layout.headerBackground}>
                <TableRow>
                  {columns?.map((column, key) => (
                    <TableHeaderCell
                      key={key}
                      onSortApi={getProjectSummaryStatusApi}
                      onSet={setProjectSummaryAwait}
                      column={column}
                      sortBy={
                        column?.isSort ? projectSummaryAwait?.sortBy : false
                      }
                    >
                      <Text className={layout.headerLabel}>{column.label}</Text>
                    </TableHeaderCell>
                  ))}
                </TableRow>
              </TableHeader>
              <TableBody isLoading={isLoading}>
                {projectSummaryAwait?.data?.map((item, key) => (
                  <ProjectSummaryAwaitRow
                    item={item}
                    key={key}
                    setOpenSummaryDetails={setOpenSummaryDetails}
                    setProjectSummaryId={setProjectSummaryId}
                    projectSummaryId={projectSummaryId}
                    openSummaryDetails={openSummaryDetails}
                  />
                ))}
              </TableBody>
            </Table>
          </Stack>

          <Pagination
            totalCount={projectSummaryAwait?.totalCount}
            itemsPerPage={projectSummaryAwait?.itemsPerPage}
            onSetListReducer={setProjectSummaryAwait}
            onGetList={getProjectSummaryStatusApi}
            page={projectSummaryAwait?.page}
          />
        </Stack>
      </Stack>
    </>
  );
};

export default ProjectSummaryAwait;
